<template>
  <div class="big-box">
    <a-layout id="components-layout-demo-custom-trigger">
      <a-layout-sider
              width="240px"
              class="menua"
              v-model="collapsed"
              :trigger="null"
              collapsible
              :theme="theme"
      >
        <div class="logo"  >
          <img src="../../assets/logo.png" alt="" class="logoimg" v-if="!collapsed"  :class="{active:collapsed}">
          <img src="../../assets/logoa.png" alt="" class="logoimgs" v-else   :class="{active:collapsed}"></div>
<!--      {{openKeys}}-->
        <a-menu
                class="menuList"
                style="width:100%;height: calc(100% - 64px);   overflow-y: auto;    "
                :style="{  paddingBottom: menubto + 'px' }"
                mode="inline"
                :theme="theme"
                :open-keys="openKeys"
                :selectedKeys=[navselected]
                @openChange="onOpenChange"
        >
          <template v-for="(item, index) in navList">
            <template v-if="item.children&&item.name==''">
              <template v-for="(itema, indexa) in item.children">
                <a-menu-item  :key="'/' + itema.name"  v-if="itema.status==1">
                  <router-link :to="'/' + itema.name"  @click.native="flushCom(`/${itema.name}`)">
                    <i class="iconfont "  :class="itema.meta.icon?itema.meta.icon:''"></i>
                    <span>{{itema.meta.title}}</span> </router-link>
                </a-menu-item>
              </template>
            </template>
            <template  v-else>
              <a-sub-menu :key="item.name" v-if="item.status==1">
                <p slot="title"><i class="iconfont"
                                   :class="item.meta.icon?item.meta.icon:''"></i><span>{{ item.meta.title }}</span></p>
                <template v-for="(items, indexs) in item.children">
                  <!--               {{items.status==1&&items.children && items.children.length > 0&&items.children.findIndex(res=>{return res.status==1})>-1}}-->
                  <a-sub-menu :key="items.name"
                              v-if="items.status==1&&items.children && items.children.length > 0&&items.children.findIndex(res=>{return res.status==1})>-1">
                    <p slot="title"><span>{{
                        items.meta.title
                      }}</span></p>
                    <a-menu-item
                        :key="'/' + item.name+'/'+itemss.name"
                        v-for="(itemss, indexs) in items.children"
                        v-if="items.children && items.children.length > 0&&items.status==1"
                    >
                      <router-link :to="'/' + item.name+'/'+itemss.name"
                                   @click.native="flushCom(`/${item.name}/${itemss.name}`)">{{ itemss.meta.title }}
                      </router-link>
                    </a-menu-item>
                  </a-sub-menu>
                  <template v-else>
                    <a-menu-item
                        :key="'/' + item.name+'/'+items.name"
                        v-if=" items.status==1"
                    >
                      <router-link :to="'/' + item.name+'/'+items.name"
                                   @click.native="flushCom(`/${item.name}/${items.name}`)">{{ items.meta.title }}
                      </router-link>
                    </a-menu-item>
                  </template>
                </template>
              </a-sub-menu>
            </template>
          </template>
        </a-menu>
      </a-layout-sider>
      <a-layout class="layout_big_box">
        <a-layout-header style="background: #fff; padding: 0;">
          <div class="flex">
            <a-icon
                    class="trigger"
                    :type="collapsed ? 'menu-unfold' : 'menu-fold'"
                    @click="() =>{collapsed = !collapsed ; openKeys=[]}  "
            />
            <div>
              <a href="https://www.chukouplus.com" target="_blank"> <a-icon type="home"  style="font-size:22px;position: relative;top:2px;right: -10px"/> </a>
            <a-dropdown :trigger="['click']" style="padding: 0 24px;">
              <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                <span class="el-dropdown-link">
                  {{ getTimes() }},{{ username }}<a-icon type="down" />
                </span>
              </a>
              <a-menu slot="overlay">
                <a-menu-item key="0" @click="changPassword">
                  修改密码
                </a-menu-item>
                <a-menu-item key="1" @click="logOut">
                  退出
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            </div>
          </div>
        </a-layout-header>
        <a-breadcrumb separator-class="el-icon-arrow-right">
          <template v-if="$route.path.split('/').length>2&&$route.meta.title!='首页'">
            <a-breadcrumb-item :to="{ path: '/Home' }">首页</a-breadcrumb-item>
            <a-breadcrumb-item  >{{ $route.meta.ptit }}</a-breadcrumb-item>
            <a-breadcrumb-item :routes="$route.path" >{{ $route.meta.title }}</a-breadcrumb-item>
          </template>
          <template v-else >
            <a-breadcrumb-item :routes="$route.path" >{{ $route.meta.title }}</a-breadcrumb-item>
          </template>
        </a-breadcrumb>
        <a-layout-content
            class="layout_content"
                :style="{}"

        >
          <a-config-provider :locale="zhCN">
            <router-view class="big_box"> </router-view>
          </a-config-provider>
        </a-layout-content>
      </a-layout>
    </a-layout>

    <ChangePassword
            :visible="visible"
            @changVisible="changVisiblePassword  " ></ChangePassword>
  </div>
</template>

<script>
  import axios from "../../utils/request";
  import ChangePassword from "./components/changePassword";
  import zhCN from 'ant-design-vue/es/locale-provider/zh_CN';
  import moment from 'moment';
  import 'moment/locale/zh-cn';
  import { resetRouter } from '../../router/router'
  moment.locale('zhCN');
  export default {
    name: "index",
    data() {
      return {
        menubto:70,
        username: window.sessionStorage.getItem("userName"),
        visible: false,
        collapsed: false,
        rootSubmenuKeys: [ ],
        openKeys:JSON.stringify(window.localStorage.getItem('openKeys')).indexOf('[')>-1?JSON.parse(window.localStorage.getItem('openKeys')):[window.localStorage.getItem('openKeys')

        ],
        selectedKeys:"",
        mode: "inline",
        theme: "light",
        navList: JSON.parse(window.sessionStorage.getItem("navData")),
        navselected:"/",
        zhCN,
      };
    },
    watch: {
      '$store.state.adminleftnavnum': 'getNavType',
    },
    methods: {
      flushCom:function(rot){
        // if(rot==this.$store.state.adminleftnavnum)this.$router.go(0);
//router是路由实例,例如:var router = new Router({})
//router.go(n)是路由的一个方法，意思是在history记录中前进或者后退多少步，0就表示还是当前，类似window.history.go(n)
//
      },
      changVisiblePassword(){
        this.visible = false;
        setTimeout(() => {
          this.$router.push('/login')
        }, 1500)
      },
      getNavType(){
        this.navselected=this.$store.state.adminleftnavnum;//store.state.adminleftnavnum里值变化的时候，设置navselected
        let _that=this
        this.$nextTick().then(function () {
          setTimeout(() => {
            if(!_that.isElementInViewport(document.querySelector(".router-link-active"))){
              _that.menubto=0
              document.querySelector(".router-link-active").scrollIntoView()
            }
          }, 500)
        })

      },
      onOpenChange(openKeys) {
        console.log('openKeys',openKeys)
        let latestOpenKey = openKeys.find((key) => this.openKeys.indexOf(key) === -1);
        if(openKeys[openKeys.length-1]=='AOrderStatistics'){
          latestOpenKey=openKeys
          this.openKeys =openKeys
          window.localStorage.setItem("openKeys", JSON.stringify(openKeys));
          return
        }else{
          window.localStorage.setItem("openKeys", latestOpenKey);
          if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            this.openKeys = openKeys;
          } else {
            this.openKeys = latestOpenKey ? [latestOpenKey] : [];
          }
        }

      },
      getTimes() {
        const time = new Date();
        const hour = time.getHours();
        return hour < 9
                ? "早上好"
                : hour <= 11
                        ? "上午好"
                        : hour <= 13
                                ? "中午好"
                                : hour < 20
                                        ? "下午好"
                                        : "晚上好";
      },
      changPassword() {
        this.visible = true;
      },
      logOut() {
        let _this = this;
        this.$confirm({
          title: "提示",
          content: "真的要注销登录吗",
          onOk() {
            axios.get("/admin/common/logout").then((res) => {
              _this.$router.push({ path: "/login" });
              sessionStorage.clear();
              resetRouter()
            });
          },
          onCancel() {},
        });
      },
      isElementInViewport(el) {
          //获取元素是否在可视区域
          if(el){
            var rect = el.getBoundingClientRect();
            return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <=
                    (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <=
                    (window.innerWidth || document.documentElement.clientWidth)
            )
          } else {
            return true
          }
      }
    },
    mounted() {
      this.getTimes();
      let menuArr=[]
      this.navList.map((item, key) => {
        menuArr.push(item.name);
      });
      this.rootSubmenuKeys=menuArr
      this.$nextTick(() => {
      this.getNavType()
      })

    },
    components: { ChangePassword },
  };
</script>

<style scoped>
body{overflow: hidden!important;box-sizing: border-box!important;}
.layout_content{ box-sizing: border-box;
  padding: 24px ;
  background: #fff;
  margin:28px 16px;
}
.layout_big_box{height: 100vh; }
  #components-layout-demo-custom-trigger {
    height: 100vh;
  }
  .layout_big_box::-webkit-scrollbar {display: none!important; width: 0 !important }
  #components-layout-demo-custom-trigger .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
  }

  #components-layout-demo-custom-trigger .trigger:hover {
    color: #1890ff;
  }

  #components-layout-demo-custom-trigger .logo {
    text-align: center;
    height: 32px;
    background: rgba(255, 255, 255, 0.2);
    margin: 16px;
  }
  .ant-menu-submenu > .ant-menu {
    background-color: #fff !important;
    color: #1890ff !important;
  }
  .menua{overflow: hidden!important;}
  .ant-menu-submenu-open {
    background-color: #fff !important;
    color: #1890ff !important;
  }
  .logoimg{width: 115px}
  .logoimgs{width: 50px}
  .iconfont{margin-right: 10px;position: relative;
    top: 1px;
    font-size: 18px;}
  .ant-layout-content{min-height: auto!important;-ms-overflow-style: none!important;  overflow: -moz-scrollbars-none!important;}
  .ant-layout-content::-webkit-scrollbar {
    display: none!important;
  }
  .menuList::-webkit-scrollbar {
    display: none;
  }
  .ant-layout.ant-layout-has-sider .ant-layout-content::-webkit-scrollbar {
    display: none!important;
  }

  .layout_big_box::-webkit-scrollbar {
    display: none!important;
    width: 0;
  }
  body{overflow: hidden}
  .ant-menu-inline-collapsed span{opacity: 0!important;}
  .ant-menu.ant-menu-inline.ant-menu-sub{  display: none!important;}
</style>
